import * as React from "react";
const SvgCropSquare = (props) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 0.5, y: 0.5, width: 13, height: 13, rx: 1.5, stroke: "currentColor" }));
export default SvgCropSquare;
